import React, { FC } from 'react'
import { Container, Row, Col, Spinner } from '@mch-group/uikit-components'
import ShowMore from '@components/ShowMore'

import Separator from '@components/Separator'
import GalleryItem from '../../../Galleries/GalleryItem'
import { useModuleContext } from '../../contexts/ArtistContext'
import useCatalogGalleriesData from '../../hooks/useCatalogGalleriesData'

const ArtistGalleries: FC<IArtistGalleries> = ({ title }) => {
  const { AltTags } = useCatalogGalleriesData()
  const { state: {
    catalogGalleriesList,
    isLoadingGalleriesNewpage,
    isLoadingGalleriesList
  },
    refs, dispatch
  } = useModuleContext()

  // Hide the component if there's no galleries data after the API call has been completed
  if (!isLoadingGalleriesList && catalogGalleriesList?.length === 0) {
    return null
  }

  return (
    catalogGalleriesList?.length > 0 ?
      <Container>
        <Separator noMarginBottom className='mb-md-10 mb-sm-11 mb-9' />
        <section className='artist-galleries mb-14'>
          <h2 className='header-uppercase-1 mb-9'>{title}</h2>
          <Row>
            {catalogGalleriesList.map(gallery => (
              <Col className='col-12 col-md-6 col-xl-3' key={gallery.id}>
                <GalleryItem
                  id={gallery.id}
                  cleanTitle={gallery.cleanTitle}
                  displayName={gallery.displayName}
                  showNames={gallery.showNames || []}
                  imageUrl={gallery.imageUrl}
                  showShowsData
                  withAddToCollection
                  labels={{
                    imageAlt: AltTags?.generalViewGallery,
                    addBtn: AltTags?.addToCollection,
                    ariaLabel: AltTags?.generalReadMoreAbout
                  }}
                />
              </Col>
            ))}
          </Row>
        </section>
        {isLoadingGalleriesNewpage && (
          <div className='d-flex align-items-center justify-content-center'>
            <Spinner variant='button' theme='light' />
          </div>
        )}
        {refs.catalogGalleriesPaginationInfo.current.total > 4 && (
          <ShowMore
            className='show-more-btn'
            isFetching={false}
            numberOfViewedItems={catalogGalleriesList?.length}
            numberOfTotalItems={refs.catalogGalleriesPaginationInfo.current
              && refs.catalogGalleriesPaginationInfo.current.total}
            //@ts-ignore
            onClick={() => {
              dispatch({ type: 'SET_IS_LOADING_MORE_GALLERIES_ITEM', payload: true })
              refs?.catalogGalleriesloadNextPageRef?.current()
            }}
            showProgressBar={catalogGalleriesList?.length === refs?.catalogGalleriesPaginationInfo?.current?.total}
            label1={'You have seen'}
            label2={'of'}
            label3={'items'}
            hideButton={refs.catalogGalleriesPaginationInfo.current
              && !refs.catalogGalleriesPaginationInfo.current.hasMore}
            showCounterLabel={catalogGalleriesList?.length === refs?.catalogGalleriesPaginationInfo?.current?.total}
          />
        )}
      </Container>
      : null
  )
}

interface IArtistGalleries {
  title: string,
  artistId: string
}

export default ArtistGalleries
